/* Built In Imports */
/* External Imports */
import { Box, Flex, Grid, Text } from '@chakra-ui/react';
/* Internal Imports */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */

const WhyWatchParty = ({ sectionContent, lang, region }) => {
  return (
    <Box
      pt={{ base: '2rem', md: '4rem' }}
      pb={{ base: '3.5rem', md: '8rem' }}
      bgImage={`url(${config.imgPath}/d/46272/1739788919-kai-pilger-ef6il87-voa-unsplash-2-1.png)`}
      bgSize="cover"
      bgPosition="center"
      px={{ base: '1rem', md: '0' }}
      bgColor="black"
      bgRepeat="no-repeat"
    >
      {/* Section Title */}
      <MsrSectionTitle
        titleObj={sectionContent[0]}
        lang={lang}
        maxwidth="582px"
      />

      {/* Cards Grid */}
      <Grid
        templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
        gap={{ base: '4rem', md: '2rem' }}
        rowGap={{ md: '4rem' }}
        mt={{ md: '4rem' }}
        maxW="797px"
        mx="auto"
      >
        {sectionContent[1].cards.map((card, index) => (
          <Flex key={index} flexDir="column" alignItems="center" gap={'1.5rem'}>
            <Box
              width={{ base: '262px', md: '263px' }}
              height={{ base: '262px', md: '263px' }}
              mx="auto"
            >
              <LazyLoadImageComponent
                width="100%"
                height="100%"
                objectFit="cover"
                src={card.thumbnail.url}
                alt={card.thumbnail.alt || card.title}
              />
            </Box>
            <Text
              color="#FFF7E9"
              fontWeight={500}
              px={
                index === 0
                  ? { base: '2rem', md: '2.5rem' }
                  : // : index === 1
                    // ? { base: '8rem', md: '6rem' }
                    { base: '0rem', md: '2.5rem' }
              }
              // px={{ md: '2.5rem' }}
              fontSize={{ base: '24px', md: '26px' }}
              lineHeight={{ base: '30.6px', md: '33.15px' }}
              fontFamily="FedraSansStd-A-medium"
              textAlign="center"
            >
              {card.title}
            </Text>
            <Text
              color="#C1C3DD"
              fontWeight="400"
              mt={{ base: '-.5rem' }}
              fontSize="1rem"
              px={
                index === 0
                  ? { base: '1rem', md: '2.5rem' }
                  : index === 2
                  ? { base: '.5rem', md: '2.5rem' }
                  : { base: '0rem', md: '2.5rem' }
              }
              lineHeight="24px"
              fontFamily="FedraSansStd-book"
              textAlign="center"
            >
              {card.description.value.document.children[0].children[0].value}
            </Text>
          </Flex>
        ))}
      </Grid>
    </Box>
  );
};

export default WhyWatchParty;
